import { cva } from "class-variance-authority";

export const supportedColors = [
  "zinc",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
  "primary",
];

export const badgeVariants = cva(
  [
    // Base
    "inline-flex items-center gap-x-1.5 px-1.5 py-0.5 text-xs/4 font-medium forced-colors:outline",
    // Icon
    "[&>[data-slot=icon]]:-mx-0.5 [&>[data-slot=icon]]:size-4 [&>[data-slot=icon]]:shrink-0",
  ],
  {
    defaultVariants: {
      border: false,
      button: false,
      color: "zinc",
      rounded: false,
    },
    variants: {
      border: {
        false: "border border-transparent",
        true: "border border-solid",
      },
      button: {
        true: "cursor-pointer transition-colors group-data-[hover]:bg-gradient-to-r from-overlay to-overlay",
      },
      color: {
        zinc: "text-badge-zinc",
        red: "text-badge-red",
        orange: "text-badge-orange",
        amber: "text-badge-amber",
        yellow: "text-badge-yellow",
        lime: "text-badge-lime",
        green: "text-badge-green",
        emerald: "text-badge-emerald",
        teal: "text-badge-teal",
        cyan: "text-badge-cyan",
        sky: "text-badge-sky",
        blue: "text-badge-blue",
        indigo: "text-badge-indigo",
        violet: "text-badge-violet",
        purple: "text-badge-purple",
        fuchsia: "text-badge-fuchsia",
        pink: "text-badge-pink",
        rose: "text-badge-rose",
        primary: "text-inverse-primary",
      },
      transparent: {
        true: "bg-transparent",
        false: "",
      },
      rounded: {
        true: "rounded-full",
        false: "rounded-md",
      },
    },
    compoundVariants: [
      { border: true, color: "zinc", class: "border-badge-zinc" },
      { border: true, color: "red", class: "border-badge-red" },
      { border: true, color: "orange", class: "border-badge-orange" },
      { border: true, color: "amber", class: "border-badge-amber" },
      { border: true, color: "yellow", class: "border-badge-yellow" },
      { border: true, color: "lime", class: "border-badge-lime" },
      { border: true, color: "green", class: "border-badge-green" },
      { border: true, color: "emerald", class: "border-badge-emerald" },
      { border: true, color: "teal", class: "border-badge-teal" },
      { border: true, color: "cyan", class: "border-badge-cyan" },
      { border: true, color: "sky", class: "border-badge-sky" },
      { border: true, color: "blue", class: "border-badge-blue" },
      { border: true, color: "indigo", class: "border-badge-indigo" },
      { border: true, color: "violet", class: "border-badge-violet" },
      { border: true, color: "purple", class: "border-badge-purple" },
      { border: true, color: "fuchsia", class: "border-badge-fuchsia" },
      { border: true, color: "pink", class: "border-badge-pink" },
      { border: true, color: "rose", class: "border-badge-rose" },

      { transparent: false, color: "zinc", class: "bg-badge-zinc" },
      { transparent: false, color: "red", class: "bg-badge-red" },
      { transparent: false, color: "orange", class: "bg-badge-orange" },
      { transparent: false, color: "amber", class: "bg-badge-amber" },
      { transparent: false, color: "yellow", class: "bg-badge-yellow" },
      { transparent: false, color: "lime", class: "bg-badge-lime" },
      { transparent: false, color: "green", class: "bg-badge-green" },
      { transparent: false, color: "emerald", class: "bg-badge-emerald" },
      { transparent: false, color: "teal", class: "bg-badge-teal" },
      { transparent: false, color: "cyan", class: "bg-badge-cyan" },
      { transparent: false, color: "sky", class: "bg-badge-sky" },
      { transparent: false, color: "blue", class: "bg-badge-blue" },
      { transparent: false, color: "indigo", class: "bg-badge-indigo" },
      { transparent: false, color: "violet", class: "bg-badge-violet" },
      { transparent: false, color: "purple", class: "bg-badge-purple" },
      { transparent: false, color: "fuchsia", class: "bg-badge-fuchsia" },
      { transparent: false, color: "pink", class: "bg-badge-pink" },
      { transparent: false, color: "rose", class: "bg-badge-rose" },
      { transparent: false, color: "primary", class: "bg-accent-primary" },
    ],
  },
);
